import { CSSProperties } from 'react';

// Per-tile hover preview of the tool's core loop. Rendered inside each home tile;
// the animations live in index.css and play only while the tile (.group) is
// hovered. Pure CSS — no video, no JS timers. Unknown keys render nothing.
export function TilePreview({ toolKey }: { toolKey: string }) {
  switch (toolKey) {
    case 'crm':
      return (
        <div className="tile-preview relative flex gap-1.5">
          <div className="flex-1 rounded-md bg-surface-3" />
          <div className="flex-1 rounded-md bg-surface-3" />
          <div className="flex-1 rounded-md bg-surface-3" />
          <div className="anim-crm absolute top-2 h-[26px] w-[30%] rounded-md bg-gradient-to-r from-power to-electric shadow-card" />
        </div>
      );

    case 'email':
      return (
        <div className="tile-preview flex flex-col justify-center gap-1.5">
          <div className="anim-type h-1.5 rounded bg-electric/70" style={cssw('55%')} />
          <div className="anim-type-2 h-1.5 rounded bg-line-strong" style={cssw('88%')} />
          <div className="flex items-center gap-1">
            <div className="anim-type-3 h-1.5 rounded bg-line-strong" style={cssw('64%')} />
            <span className="anim-caret inline-block h-3 w-[2px] bg-soft" />
          </div>
        </div>
      );

    case 'caller':
      return (
        <div className="tile-preview flex flex-col justify-center gap-2">
          <div className="relative mx-1 h-1 rounded-full bg-surface-3">
            {[0, 33, 66, 100].map((l) => (
              <span key={l} className="absolute -top-[3px] h-[7px] w-[7px] -translate-x-1/2 rounded-full bg-line-strong" style={{ left: `${l}%` }} />
            ))}
            <span className="anim-call-dot absolute -top-[5px] h-[11px] w-[11px] -translate-x-1/2 rounded-full bg-success shadow-card" />
          </div>
          <div className="flex justify-between px-0.5 text-[8px] font-semibold uppercase tracking-wide text-muted">
            <span>New</span><span>Called</span><span>Warm</span><span>Won</span>
          </div>
        </div>
      );

    case 'lead_finder':
      return (
        <div className="tile-preview flex items-center justify-between">
          <div className="font-display text-4xl font-extrabold leading-none text-soft">
            <span className="score-num anim-score" />
          </div>
          <span className="anim-badge rounded-md border border-danger/50 bg-danger/15 px-2 py-1 text-[11px] font-extrabold uppercase tracking-wide text-danger">
            Hot
          </span>
        </div>
      );

    case 'content':
      return (
        <div className="tile-preview grid grid-cols-7 grid-rows-2 gap-1">
          {Array.from({ length: 14 }).map((_, i) => (
            <div key={i} className="anim-cell rounded-sm bg-electric/50" style={{ animationDelay: `${i * 0.07}s` }} />
          ))}
        </div>
      );

    default:
      return null;
  }
}

function cssw(w: string): CSSProperties {
  return { ['--w' as string]: w } as CSSProperties;
}
